// Chips.js
import React from 'react';
import Chip from '@mui/material/Chip';
import styled from 'styled-components';

const ChipsWrap = styled.div`
	display: flex;
	flex-wrap: nowrap;
	gap: 6px;
	overflow-x: auto;
	overflow-y: hidden;
	padding-bottom: 4px;
	scroll-behavior: smooth;

	scrollbar-width: thin;
	scrollbar-color: rgba(0, 0, 0, 0.3) transparent;

	&::-webkit-scrollbar {
		height: 6px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: rgba(0, 0, 0, 0.3);
		border-radius: 3px;
	}

	&::-webkit-scrollbar-track {
		background: transparent;
	}
`;

export function Chips({ tags }) {
	if (!tags || !tags.length) return null;

	return (
		<div style={{ marginBottom: 12 }}>
			<ChipsWrap>
				{tags.map((tag, i) => (
					<Chip
						key={i}
						label={tag}
						color="primary"
						size="small"
						sx={{
							'& .MuiChip-label': {
								fontSize: '1.1rem',
								marginBottom: '-2px',
								whiteSpace: 'nowrap',
							},
						}}
					/>
				))}
			</ChipsWrap>
		</div>
	);
}
